module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp2_7016.c85b538c.png";